<template>
  <generic-modal :modal-key="''"
                 :classStyle="'popup_box ungame_balance_popup modal_cont'"
                 :idProp="''"
                 @close="closeModal">
    <template slot="content">
      <h1>{{ getTranslations.home_modal_unlocked_you_have }} {{ userDetails.availableGames }}
          {{ getTranslations.home_modal_unlocked_unlocked_games }}</h1>
      <h6>{{ getTranslations.home_modal_unlocked_play_them }}!</h6>
      <img src="static/images/popups/unlocked_games.png" class="ungame_bal_img">
      <p>{{ getTranslations.home_modal_unlocked_unlocked_games_after }} <span>{{ getTranslations.home_modal_unlocked_end_time  }}</span>
         {{ getTranslations.home_modal_unlocked_and_converts_to }}
         <span>{{ getTranslations.home_modal_unlocked_game }}</span></p>
      <button type=""  @click.prevent="playMethod">{{ getTranslations.home_modal_unlocked_new_game_button }}     </button>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import modals from '@/common/modals';
import NewGameMixin from '@/common/mixins/home';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'unlocked-games-modal',
  components: { GenericModal },
  mixins: [NewGameMixin],
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    playMethod() {
      this.playGame();
    },
    openNewGameModal() {
      // this.storeModalForHomePage(NewGameModal);
      modals.showHideModal(this);
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/unlockedgames/UnlockedGamesModal.vue